import React, { useState } from 'react';
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import LeaveConfirmModal from "./LeaveConfirmModal";
import "../../../styles/vipcode.css";
import { isAlphanumeric } from "../../../js/helper";

const MAX_LENGTH = 20;

export const ClientsCode = (logic) => {
  const [localCode, setLocalCode] = useState("");
  const [errorMsg, setErrorMsg] = useState("");      // inline field validation only
  const [showLeaveConfirm, setShowLeaveConfirm] = useState(false);

  const handleAttemptClose = () => {
    logic.handleClientsCodeClose && logic.handleClientsCodeClose();
  };

  const handleLeaveCancel = () => {
    setShowLeaveConfirm(false);
  };

  const handleLeaveConfirmed = () => {
    setShowLeaveConfirm(false);
    if (logic.handleCancelFlow) {
      logic.handleCancelFlow();
    } else {
      logic.handleClientsCodeClose && logic.handleClientsCodeClose();
    }
  };

  const isControlled = logic.clientCode !== undefined;
  const codeValue = isControlled ? logic.clientCode : localCode;

  const handleChange = (e) => {
    const val = e.target.value;
    if (val.length > MAX_LENGTH) return;
    setErrorMsg("");
    if (!isControlled) setLocalCode(val);
    logic.handleClientCodeChange && logic.handleClientCodeChange(e);
  };

  const handleApply = () => {
    if (!codeValue.trim()) {
      setErrorMsg("Please enter a client code");
      return;
    }
    if (!isAlphanumeric(codeValue.trim())) {
      setErrorMsg("Please enter alphanumeric code");
      return;
    }
    // Any API / QR error is surfaced by VipCode.js through the Authentication modal.
    logic.handleApplyClientCode && logic.handleApplyClientCode();
  };

  const hasError = !!errorMsg;

  const modalProps = {
    dialogClassName: "clients-code-modal",
    show: logic.showClientsCode ?? true,
    onHide: handleAttemptClose,
    animation: false,
    centered: true
  };

  return (
    <>
      <Modal
        className="client-code-modal"
        {...modalProps}>
        <Modal.Header closeButton className="cc-header">
          <Modal.Title className="cc-title">Client's code</Modal.Title>
        </Modal.Header>

        <Modal.Body className="cc-body">
          <input
            type="text"
            placeholder="e.g. FG11HHG"
            value={codeValue}
            onChange={handleChange}
            maxLength={MAX_LENGTH}
            className={`cc-input ${hasError ? "cc-input--error" : codeValue ? "cc-input--filled" : "cc-input--empty"
              }`}
          />
          {hasError && <p className="cc-input-error-msg">{errorMsg}</p>}

          <div className="d-grid gap-2">
            <Button
              className={`btn btn-primary p-2 cc-apply-btn ${codeValue ? "cc-apply-btn--active" : "cc-apply-btn--disabled"
                }`}
              onClick={handleApply}
            >
              Apply
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <LeaveConfirmModal
        show={showLeaveConfirm}
        onCancel={handleLeaveCancel}
        onConfirm={handleLeaveConfirmed}
      />
    </>
  );
};

export default ClientsCode;
